import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["orderId", "apiKey", "accountId", "callBack"]

    connect() {
        document.getElementById('new-payment-modal').classList.remove('is-active');
        const options = {
            "key": this.apiKeyTarget.textContent,
            "order_id": this.orderIdTarget.textContent,
            "description": "Test Transaction",
            "account_id": this.accountIdTarget.textContent,
            "callback_url": this.callBackTarget.textContent,
            "redirect": true
        }
        const rzp1 = new Razorpay(options);
        rzp1.open()
    }

}